import React, { useEffect, useState } from 'react';
import RequestAccess from "../components/RequestAccess";

const LearnSection = () => {
    const [showForm, setShowForm] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const containerStyle = {
    background: 'radial-gradient(107.67% 107.67% at 50% 20.81%, #000B3E 0%, #020202 100%)',
    color: '#fff',
    padding: isMobile ? '40px 20px' : '40px 80px',
    textAlign: 'center',
    
  };

  const headingStyle = {
    fontSize: isMobile ? '26px' : '32px',
    fontWeight: '700',
    marginBottom: '30px'
  };

  const highlightStyle = {
    color: '#f85a40'
  };

  const cardContainerStyle = {
    display: 'grid',
    gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
    gap: '15px',
    marginBottom: '40px'
  };

  const cardStyle = {
    backgroundColor: '#18215c',
    borderRadius: '12px',
    padding: '30px',
    textAlign: 'left',
    position: 'relative',
    opacity: 0,
    animationName: 'fadeInUp',
    animationDuration: '1s',
    animationFillMode: 'forwards',
    minHeight: '150px',
    maxWidth: '420px'
  };

  const labelStyle = {
    backgroundColor: '#f1e400',
    color: '#000',
    fontWeight: '600',
    borderRadius: '10px 0px 10px',
    padding: '3px 8px',
    fontSize: '14px',
    display: 'inline-block',
    marginBottom: '6px'
  };

  const headingInsideCard = {
    fontSize: '17px',
    fontWeight: '700',
    color: '#f85a40',
    marginBottom: '8px',
    lineHeight: '1.2'
  };

  const cardTextStyle = {
    fontSize: '15px',
    fontWeight: '500',
    color: '#fff',
    lineHeight: '1.4',
    margin: 0
  };

  const buttonStyle = {
    background: 'linear-gradient(to right, #f8b500, #e68a00)',
    border: 'none',
    fontSize: isMobile ? '16px' : '20px',
    padding: isMobile ? '12px 30px' : '14px 40px',
    fontWeight: '700',
    color: '#000',
    borderRadius: '12px',
    cursor: 'pointer',
    width: isMobile ? '90%' : '60%',
    animation: 'wiggle 1.5s ease-in-out infinite',
  };

  const cardData = [
    { label: '#1', heading: "Business Owners & Entrepreneurs", items: ["Wasting hours writing ads and marketing content", "No fresh ideas for attracting customers", "Struggling to reply to leads on time","High cost for hiring content & copywriters"] },
    { label: '#2', heading: "Social Media Managers & Content Creators", items: ["Running out of post ideas every week", "Slow caption & script writing process", "Inconsistent brand tone in content", "Missing trending topics due to delays"] },
    { label: '#3', heading: "Students & Competitive Exam Aspirants", items: ["Finding study material takes too much time", "Confused about complex topics and explanations", "No proper mock test questions readily available", "Struggling with time management for studies"] },
    { label: '#4', heading: "Job Seekers & Professionals", items: ["Resume not standing out to employers", "Difficulty preparing for job interviews", "No clear career growth roadmap", "Trouble learning new professional skills"] },
    { label: '#5', heading: "Website & Design Professionals", items: ["Stuck on creative design ideas", "Content writing delays for web pages", "Struggling with UX improvement suggestions", "Client feedback takes too long to apply"] },
    { label: '#6', heading: "Health, Fitness & Lifestyle Coaches", items: ["No unique workout or diet content ideas", "Difficulty engaging audience with health tips", "Time-consuming research for accurate facts", "Repeating same ideas in videos & posts"] }
  ];

  return (
    <>
    <div style={containerStyle}>
      <h2 style={headingStyle}>
        Struggling Daily? <br />
        <span style={highlightStyle}>See How ChatGPT Could Solve These Problems</span>
      </h2>

      <div style={cardContainerStyle}>
        {cardData.map((card, i) => (
          <div key={i} style={{ ...cardStyle, animationDelay: `${i * 0.2}s` }}>
            <div style={labelStyle}>{card.label}</div>
            <div style={headingInsideCard}>{card.heading}</div>
            <ol style={{ ...cardTextStyle, paddingLeft: '18px' }}>
              {card.items.map((item, idx) => (
                <li key={idx}>{item}</li>
              ))}
            </ol>
          </div>
        ))}
      </div>

      <button style={buttonStyle}
      onClick={() => setShowForm(true)}
      >
        Just ₹199 Limited Time Only
      </button>

      <style>
        {`
          @keyframes fadeInUp {
            0% { opacity: 0; transform: translateY(30px); }
            100% { opacity: 1; transform: translateY(0); }
          }
          @keyframes wiggle {
            0% { transform: translateX(0); }
            15% { transform: translateX(-4px); }
            30% { transform: translateX(4px); }
            45% { transform: translateX(-4px); }
            60% { transform: translateX(4px); }
            75% { transform: translateX(-2px); }
            100% { transform: translateX(0); }
          }
        `}
      </style>
      <div style={{padding:'30px',fontSize:'22px',textAlign:'center',color:'#fff',marginBottom:'-20px'}}>
      <p>From business owners to students, and from creators to coaches, dozens of industries struggle<br/> daily losing time, opportunities, and growth simply because they lack the right tools.</p>
     </div>
    </div>
    
          {/* Popup Form */}
          {showForm && <RequestAccess onClose={() => setShowForm(false)} />}
    
    </>
  );
};

export default LearnSection;
